import React, { useState } from "react";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import Xml from "./Xml"; // Assuming you already have this component
import SecondaryButton from "../buttons/SecondaryButton";
import CloseIcon from "@mui/icons-material/Close"; // Optional close icon
import { useTheme } from "@emotion/react";
import { getDocDataByRef, updateDocDataField } from "../models/DataFunctions";
import Icon1 from "../icons/Icon";
import Space from "../layout/Space";
import getTemporaryUrl from "../api/getTemporaryUrl";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import { useAppContext } from "../config/AppContext";
import { folder } from "jszip";
import downloadFile from "../api/download/downloadFile";
import { useSnackbar } from "notistack";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import Modal1 from "../modals/Modal1";
import { isFolderAdmin } from "../pages/folder_pages/FolderHelpers";
import PrimaryButton from "../buttons/PrimaryButton";
import refreshCounters from "../api/refreshCounters";

const XmlModal = ({
  document,
  children,
  folder,
  orgData,
  userData,
  setModalOpen,
  modif_thermal_xml,
  onFetch,
  handleAskExpert,
}) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const handleOpen = (e) => {
    e.stopPropagation();
    setOpen(true);
    setModalOpen(true); // Notify parent that modal is open
  };

  const handleFetchAgain = () => {
    setOpen(false);
    setModalOpen(false); // Notify parent that modal is closed
    onFetch();
  };

  const handleDelete = (id) => {
    setOpen(false);
    setModalOpen(false); // Notify parent that modal is closed
    onDelete(id); // Assuming you have this onDelete function
  };

  const handleValidate = async () => {
    await updateDocDataFieldApi(folder.ref, "xml.state", "done", prefix);
    const token = await getOrRefreshFirebaseToken();
    await refreshCounters(token, folder.id, prefix);
    handleClickVariant("XML validé", "success");
  };

  const handleDownloadExtracted = async () => {
    const token = await getOrRefreshFirebaseToken();
    await getTemporaryUrl(token, "xml", "", folder.id, prefix);
    let folderData = await getDocDataByRef(folder.ref);
    let file = folderData.last_file_extracted;
    downloadFile(file, "ATH_extraite_" + folderData.nom + ".pdf");
    handleClickVariant("Fichier extrait téléchargé", "success");
  };

  const handleDeleteExtracted = async () => {
    await updateDocDataFieldApi(
      folder.ref,
      "last_file_extracted",
      null,
      prefix
    );
    await updateDocDataFieldApi(folder.ref, "xml.extracted", false, prefix);
    onFetch();
  };

  const handleClose = () => {
    setOpen(false);
    setModalOpen(false); // Notify parent that modal is closed
  };

  const [onHover, setOnHover] = useState(false);

  return (
    document && (
      <div className="w-full h-full justify-center items-center align-middle bg-transparent">
        {/* Button to open the modal */}
        <div className="h-fit w-fit flex flex-row cursor-pointer bg-transparent">
          {folder.last_file_extracted && document.state === "done" && (
            <>
              <div
                className=" px-2 py-0 w-24 min-w-24 text-center border-1 text-h3 rounded-md text-shadow_50"
                style={{
                  backgroundColor: theme.palette.accent1.light,
                  color: theme.palette.accent1.main,
                }}
              >
                Extrait
              </div>
              <Space x={7} />
              <div className="w-4 min-w-4" onClick={handleDownloadExtracted}>
                <Icon1
                  icon_name="download"
                  height="16px"
                  width="16px"
                  fill={theme.palette.shadow._50}
                />
              </div>{" "}
              <Space x={4} />
              <div
                className="w-4 min-w-4"
                onClick={handleDeleteExtracted}
                onMouseEnter={() => setOnHover(true)}
                onMouseLeave={() => setOnHover(false)}
              >
                <Icon1
                  icon_name="delete"
                  height="16px"
                  width="16px"
                  fill={
                    onHover
                      ? theme.palette.accent2.main
                      : theme.palette.shadow._50
                  }
                />
              </div>
              <Space x={7} />
            </>
          )}
          {document.state === "wait" && isFolderAdmin(orgData, folder) && (
            <PrimaryButton
              sx={{ fontSize: "13px", borderRadius: "8px", minWidth: "80px" }}
              onClick={handleValidate}
            >
              Valider
            </PrimaryButton>
          )}

          {!folder.xml.extracted &&
            document.state === "done" &&
            isFolderAdmin(orgData, folder) && (
              <PrimaryButton
                sx={{ fontSize: "13px", borderRadius: "8px", minWidth: "80px" }}
                onClick={handleOpen}
              >
                Extraire
              </PrimaryButton>
            )}

          {!folder.xml.file?.id &&
            folder.xml.state !== "wait" &&
            folder.xml.state !== "done" &&
            !modif_thermal_xml && (
              <div className="flex flex-row gap-2">
                {" "}
                <SecondaryButton
                  sx={{
                    fontSize: "13px",
                    borderRadius: "8px",
                    minWidth: "160px",
                  }}
                  onClick={handleAskExpert}
                >
                  Demander le dépôt
                </SecondaryButton>
                {folder.xml.requested && (
                  <div className=" rounded-xl py-0.5 text-accent2  bg-red-100 px-2 text-h2  w-fit">
                    Demandé
                  </div>
                )}
              </div>
            )}

          {children}
        </div>

        {/* Modal dialog */}
        <Modal1 isOpen={open} onClose={handleClose}>
          <div className="bg-white  rounded-xl  flex flex-col">
            <div className=" justify-between flex flex-row p-4 border-b-1">
              <div className="text-h2">Extraction</div>

              <div
                className="text-h3 text-shadow_50 cursor-pointer"
                onClick={handleClose}
              >
                Fermer
              </div>
            </div>
            {/* Event Content */}
            <Xml
              document={document}
              folder={folder}
              orgData={orgData}
              userData={userData}
              onClose={handleClose}
              onDelete={handleDelete}
              onFetch={handleFetchAgain}
              prefix={prefix}
              modif_thermal_xml={modif_thermal_xml}
            />
          </div>
        </Modal1>
      </div>
    )
  );
};

export default XmlModal;
